var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#020203;}\r\n\t.st5{fill:none;}\r\n\t.st6{display:inline;opacity:0.3;}\r\n\t.st7{fill:#616160;}\r\n\t.st8{fill:none;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st9{display:inline;fill:none;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st10{display:inline;fill:none;stroke:#616160;}\r\n\t.st11{display:inline;fill:#616160;}\r\n\t.st12{display:none;opacity:0.5;}\r\n\t.st13{display:inline;opacity:0.58;}\r\n\t.st14{fill:#010202;}\r\n\t.st15{fill:#F0F0F0;}\r\n\t.st16{fill:#1F70B7;}\r\n\t.st17{fill:none;stroke:#C4C4C4;stroke-width:0.5;}\r\n\t.st18{fill:#2470B7;}\r\n\t.st19{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st20{fill:none;stroke:#B4B0B0;stroke-width:0.5;}\r\n\t.st21{fill:#C4C4C4;}\r\n\t.st22{fill:none;stroke:#C4C4C4;stroke-width:2;}\r\n\t.st23{fill:#1D70B8;}\r\n\t.st24{fill:none;stroke:#1D70B8;stroke-width:2;}\r\n\t.st25{fill:none;stroke:#1D70B8;}\r\n\t.st26{fill:none;stroke:#1D70B8;stroke-width:3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Editabl",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M9.1236,12.1064h0.5c0.1381,0,0.25-0.1119,0.25-0.25v-5.5c0-0.1381-0.1119-0.25-0.25-0.25h-0.5 c-0.1381,0-0.25,0.1119-0.25,0.25v5.5C8.8736,11.9944,8.9855,12.1064,9.1236,12.1064z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M6.3764,12.1064h0.5c0.1381,0,0.25-0.1119,0.25-0.25v-5.5c0-0.1381-0.1119-0.25-0.25-0.25h-0.5 c-0.1381,0-0.25,0.1119-0.25,0.25v5.5C6.1264,11.9944,6.2383,12.1064,6.3764,12.1064z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M14.9072,2.7471h-1.5869H2.8232H1.0928v1h1.7305v10.3457c0,0.5137,0.418,0.9316,0.9316,0.9316h8.6338 c0.5137,0,0.9316-0.418,0.9316-0.9316V3.7471h1.5869V2.7471z M12.3203,14.0254l-8.4971,0.0674V3.7471h8.4971V14.0254z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.4102,
    y: 1.0195,
    className: "st7",
    width: 5.1797,
    height: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTheme);
export default __webpack_public_path__ + "static/media/DeleteTheme.4bc1c5bb3ea347a6d360ab6c074bc2c7.svg";
export { ForwardRef as ReactComponent };